import React from 'react'
import { DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import { DialogActions, DialogContent, Button, Dialog, DialogContentText, DialogTitle, Box } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { useLoading } from '../../atoms/Loading'
import { useChangeOutsideStatus } from '../../molecules/PaperDetailsModal/hooks'
import { useLogin } from '../../organisms/Login'

const texts = {
  buttonLabel: 'Outside Request',
  buttonLabelIsOutsideRequested: 'Outside Requested',
  cancelLabel: 'Cancel',
  title: 'Is the scope of the paper outside of CPSY?',
  content:
    'This operation does NOT destroy the paper. The administrator makes the final decision and executes outside. Thank you for contributing to CPSYMAP.'
}

export const OutsideRequestButton: React.FC<{ paper: DetailedPaper }> = ({ paper }) => {
  const [open, setOpen] = React.useState(false)
  // const { outsideRequest } = useUsecasePaper() // NOTE: 権限的に使いにくいのでgql側で操作する
  const changeOutsideStatus = useChangeOutsideStatus()
  const { handleIsLoading } = useLoading()
  const login = useLogin()
  const snackbar = useSnackbar()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOutsideRequest = async () => {
    handleIsLoading(true)

    if (!login.isLoggedIn()) {
      login.handleOpen()
      snackbar.enqueueSnackbar('Require Login.', { variant: 'error' })
      handleClose()
      handleIsLoading(false)
      return
    }

    try {
      // outsideRequest処理
      // await outsideRequest(paper.id) // NOTE: 権限的に使いにくいのでgql側で操作する
      await changeOutsideStatus.outsideRequest({ paperId: paper.id })
      //
      snackbar.enqueueSnackbar('Successfully outsideRequest.', {
        variant: 'success'
      })
      handleClose()
      // handlePaperDetailsModalClose()
    } catch (error) {
      console.log('error', error)
      snackbar.enqueueSnackbar('Oops! something went wrong.', {
        variant: 'error'
      })
      handleClose()
    } finally {
      handleIsLoading(false)
    }
  }

  const isOutsideRequested = paper.outsideRequest === true

  return (
    <>
      <Box style={{ textAlign: 'center', margin: '10px' }}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          disabled={isOutsideRequested}
          onClick={handleClickOpen}
        >
          {isOutsideRequested ? texts.buttonLabelIsOutsideRequested : texts.buttonLabel}
        </Button>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{texts.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{texts.content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <Button onClick={handleClose} color="default" autoFocus>
            {texts.cancelLabel}
          </Button>
          <Button
            onClick={async () => {
              await handleOutsideRequest()
            }}
            color="primary"
          >
            {texts.buttonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
